import api from '@/api/Api'
export const state = {
  crs: []
}

export const getters = {
  crs (state) {
    return state.crs
  }
}

export const mutations = {
  SET_CRS (state, newValue) {
    state.crs = newValue
  }
}
export const actions = {
  fetchCrs ({ commit }, search) {
    return api.getCrs({ search: search }).then(response => {
      const crs = response.data.data
      commit('SET_CRS', crs)
      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/tool.js